;(function($, window, document){
    window.LightboxZoom = Me.view.extend({
        options: {
            isMobile: false,
            imagePanAvailable:{
                width: false,
                height: false
            },
            imageWidth: null,
            imageHeight: null,
            lightboxParams: null,
            dragCoordinates: {
                x:0,
                y:0
            }

        },

        initialize: function() {
            _.bindAll(this, 'displayLightbox', 'closeLightbox', 'breakpointChanged', 'keypressHandler', 'resizeHandler', 'imageLoaded', 'initPanImage','touchStartHandler', 'touchEndHandler', 'touchMoveHandler');
            this.addEvents();
        },
        addEvents: function() {
            Me.dispatch.subscribe('LIGHTBOX.ZOOM', this.displayLightbox);
            this.$('.close-button').on('click', this.closeLightbox);
            Me.dispatch.subscribe('breakpointChanged', this.breakpointChanged)
            $(window).resize(this.resizeHandler);
        },
        breakpointChanged: function(e, params){
            if(params.breakpoint == '768-1023' || params.breakpoint == '767-'){
                this.options.isMobile = true;
            }
        },
        displayLightbox: function(e, params){
            this.$el.addClass('active');
            $('body').addClass('no-scroll');

            var view = this;

            this.options.lightboxParams = params;

            this.$('.image-container.current-image img').attr('src', params.lightboxSrc);

            if(this.$('img').get(0).complete) {
                this.imageLoaded();
            }
            else {
                this.$('img').on('load', function() {
                    view.imageLoaded();
                });
            }

            $(window).on('keydown', this.keypressHandler);
        },
        resizeHandler: function(e){
            this.initPanImage();
        },
        imageLoaded: function(){
            this.initPanImage();
        },
        initPanImage: function(){

            this.options.imageWidth =  this.$('img').width();
            this.options.imageHeight = this.$('img').height();

            // if(this.options.isMobile){
            //     this.options.imageWidth = this.$('img').width() * 0.5;
            //     this.options.imageHeight = this.$('img').height() * 0.5;
            //     this.$('img').css('transform', 'scale(0.5)');
            // }else{
            //     this.options.imageWidth =  this.$('img').width();
            //     this.options.imageHeight = this.$('img').height();
            // }

            //prevent from panning top-down if image is already fully visible
            if(this.options.imageHeight > $(window).height()){
                this.options.imagePanAvailable.height = true;
            }else{
                this.options.imagePanAvailable.height = false;
            }
            //prevent from panning sideways if image is already fully visible
            if(this.options.imageWidth > $(window).width()){
                this.options.imagePanAvailable.width = true;
            }else{
                this.options.imagePanAvailable.width = false;
            }

            //whenever we can pan in one direction, activate the pan events
            if(this.options.imagePanAvailable.width || this.options.imagePanAvailable.height){
                this.$('img').on('mousedown touchstart', this.touchStartHandler);
                this.$('img').css({'top': - (this.options.imageHeight - $(window).height())/2, 'left':  - (this.options.imageWidth - $(window).width())/2})
            }else{
                this.$('img').off('mousedown touchstart', this.touchStartHandler);
            }
        },
        touchStartHandler: function(e){
            e.preventDefault();
            $('html').on('mouseup touchend', this.touchEndHandler);
            this.$('img').on('mousemove touchmove', this.touchMoveHandler);

            //mouse or touch events
            if(e.originalEvent.pageX){
                this.options.dragCoordinates.x = e.originalEvent.pageX;
                this.options.dragCoordinates.y = e.originalEvent.pageY;
            }else{
                this.options.dragCoordinates.x = e.originalEvent.changedTouches[0].clientX;
                this.options.dragCoordinates.y = e.originalEvent.changedTouches[0].clientY;
            }
        },
        touchMoveHandler: function(e) {
            var newTopPosition;
            var newLeftPosition;

            //mouse or touch events
            if(e.originalEvent.pageX){
                newTopPosition = parseInt(this.$('img').css('top')) + (e.originalEvent.pageY - this.options.dragCoordinates.y);
                newLeftPosition = parseInt(this.$('img').css('left')) + (e.originalEvent.pageX - this.options.dragCoordinates.x);

            }else{
                newTopPosition = parseInt(this.$('img').css('top')) + (e.originalEvent.changedTouches[0].clientY - this.options.dragCoordinates.y);
                newLeftPosition = parseInt(this.$('img').css('left')) + (e.originalEvent.changedTouches[0].clientX - this.options.dragCoordinates.x);
            }

            //boundaries validation
            if(newTopPosition > 0){
                newTopPosition = 0;
            }else if(newTopPosition < - (this.options.imageHeight - $(window).height())){
                newTopPosition = - (this.options.imageHeight - $(window).height());
            }

            if(newLeftPosition > 0){
                newLeftPosition = 0;
            }else if(newLeftPosition < - (this.options.imageWidth - $(window).width())){
                newLeftPosition = - (this.options.imageWidth - $(window).width());
            }

            //pan sideways if available
            if(this.options.imagePanAvailable.width){
                this.$('img').css({
                    'left': newLeftPosition
                });
            }

            //pan top-down if available
            if(this.options.imagePanAvailable.height) {
                this.$('img').css({
                    'top': newTopPosition
                });
            }

            //mouse or touch events
            if(e.originalEvent.pageX){
                this.options.dragCoordinates.x = e.originalEvent.pageX;
                this.options.dragCoordinates.y = e.originalEvent.pageY;
            }else{
                this.options.dragCoordinates.x = e.originalEvent.changedTouches[0].clientX;
                this.options.dragCoordinates.y = e.originalEvent.changedTouches[0].clientY;
            }
        },
        touchEndHandler: function(){
            $('html').off('mouseup touchend', this.touchEndHandler);
            this.$('img').off('mousemove touchmove', this.touchMoveHandler);
        },
        closeLightbox: function(){
            $(window).off('keydown', this.keypressHandler);
            this.$el.removeClass('active');
            $('body').removeClass('no-scroll');

            this.options.lightboxParams = null;
            this.options.currentSlide = 1;
            this.$('.image-container.current-image img').attr('src','');
        },
        keypressHandler: function(e){
            if(e.keyCode == 27){
                //escape
                this.closeLightbox();
            }
        }
    });
}(jQuery, window, document));
